import type { ReactConfigurationGeneratorApi } from '@ingenico/react-configuration-generator';
import { sectionContainerAtom } from '@ingenico/react-section-utils';
import deepEqual from 'fast-deep-equal';
import { createStore, Provider } from 'jotai';
import type { ForwardedRef, ReactElement } from 'react';
import { forwardRef, memo, useMemo } from 'react';
import { deviceManagementContainer } from '../../container.const';
import type { ConfigurationFormBuilderWrapperProps } from '../configuration-form-builder-wrapper/ConfigurationFormBuilderWrapper.ctrl';
import { DeviceManagementConfigurationProvider } from '../configuration-form-builder-provider/ConfigurationFormBuilderProvider.ctrl';

export function ExposedConfigurationFormBuilderWrapperCpnt(
  { inputs, initialCategory, customComponents }: ConfigurationFormBuilderWrapperProps,
  ref: ForwardedRef<ReactConfigurationGeneratorApi>,
): ReactElement {
  // Pre-initialize the section container on a fresh store before any child renders, because
  // when loading from another section like provisioning, the component will try to get access
  // to the configuration business service which lives in the device management section.
  // @ingenico/react-section-utils reads sectionContainerAtom synchronously during render and
  // throws if it is null, so the value must be set before the Provider mounts its children.
  const store = useMemo(() => {
    const sectionStore = createStore();
    sectionStore.set(sectionContainerAtom, deviceManagementContainer);
    return sectionStore;
  }, []);

  return (
    <Provider store={store}>
      <DeviceManagementConfigurationProvider
        inputs={inputs}
        initialCategory={initialCategory}
        customComponents={customComponents}
        ref={ref}
      />
    </Provider>
  );
}

export const ExposedConfigurationFormBuilderWrapper = memo(
  forwardRef(ExposedConfigurationFormBuilderWrapperCpnt),
  deepEqual,
);
